import { render, staticRenderFns } from "./RevenueDetailInfo.vue?vue&type=template&id=2f805d93&scoped=true"
import script from "./RevenueDetailInfo.vue?vue&type=script&lang=js"
export * from "./RevenueDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./RevenueDetailInfo.vue?vue&type=style&index=0&id=2f805d93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f805d93",
  null
  
)

export default component.exports